
import React, { useEffect, useState } from 'react'
import { Table, TableBody, TableCaption, TableCell, TableHead, TableHeader, TableRow } from '../ui/table'
import { Avatar, AvatarImage } from '../ui/avatar'
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover'
import { Edit2, MoreHorizontal } from 'lucide-react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const CompaniesTable = () => {
    const { companies, searchCompanyByText } = useSelector(store => store.company);
    const [filterCompany, setFilterCompany] = useState(companies);
    const navigate = useNavigate();
    useEffect(()=>{
        const filteredCompany = companies.length >= 0 && companies.filter((company)=>{
            if(!searchCompanyByText){
                return true
            };
            return company?.name?.toLowerCase().includes(searchCompanyByText.toLowerCase());

        });
        setFilterCompany(filteredCompany);
    },[companies,searchCompanyByText])
    return (
        <div>
        <Table>
            <TableCaption style={{ color: '#7f99b5' }}>A list of your recent registered companies</TableCaption>
            <TableHeader>
                <TableRow>
                    <TableHead style={{ color: '#7f99b5' }}>Logo</TableHead>
                    <TableHead style={{ color: '#7f99b5' }}>Name</TableHead>
                    <TableHead style={{ color: '#7f99b5' }}>Date</TableHead>
                    <TableHead className="text-right" style={{ color: '#7f99b5' }}>Action</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {
                    filterCompany?.map((company) => (
                        <TableRow key={company._id}>
                            <TableCell>
                                <Avatar>
                                    <AvatarImage src={company.logo} />
                                </Avatar>
                            </TableCell>
                            <TableCell style={{ color: '#7f99b5' }}>{company.name}</TableCell>
                            <TableCell style={{ color: '#7f99b5' }}>{company.createdAt.split("T")[0]}</TableCell>
                            <TableCell className="text-right cursor-pointer" style={{ color: '#7f99b5' }}>
                                <Popover>
                                    <PopoverTrigger><MoreHorizontal /></PopoverTrigger>
                                    <PopoverContent className="w-32">
                                        <div onClick={() => navigate(`/admin/companies/${company._id}`)} className='flex items-center gap-2 w-fit cursor-pointer'>
                                            <Edit2 className='w-4' />
                                            <p>Edit</p>
                                        </div>
                                    </PopoverContent>
                                </Popover>
                            </TableCell>
                        </TableRow>
                    ))
                }
            </TableBody>
        </Table>
    </div>
    
    )
}

export default CompaniesTable
